import React, { FC, Fragment, useContext, useEffect } from 'react';
import parse from 'html-react-parser';
import { Col, Row } from 'react-bootstrap';
import { MatchMediaContext } from 'context/MatchMediaContext';
import { AnimationHomeSectionHero } from './animations';
import PointingPath from '../../../images/icons/PointingPath';
import HomeSectionHeader from './HomeSectionHeader';
import dictData from '../../../dictionary';
import routeList from '../../../routes/routeList';
import heroIcons, { IconsMap } from './heroIcons';

import HeroPeople from '../../../images/home-osehero-people.png';

const HomeSectionHero: FC = () => {
  const { isLg } = useContext(MatchMediaContext);
  useEffect(AnimationHomeSectionHero, []);

  return (
    <section className="home-section-hero">
      <div className="home-section-hero-presentation-container">
        <div className="home-section-hero-presentation-wrapper">
          <div className="home-section-hero-presentation-background-container">
            <div className="home-section-hero-presentation-background" />
          </div>
          <div className="home-section-hero-content content-wrapper">
            {isLg && (
              <>
                <div className="home-section-hero-top-pointer">
                  <PointingPath className="home-section-hero-path-top" long />
                </div>
                <div className="home-section-hero-bottom-pointer">
                  <PointingPath className="home-section-hero-path-bottom" />
                </div>
              </>
            )}
            <HomeSectionHeader
              subtitle={dictData.home.homeSectionPresentation.subtitle}
              title={dictData.home.homeSectionPresentation.title}
              description={dictData.home.homeSectionPresentation.description}
              ctaHref={routeList.oseHero}
              ctaButtonText={dictData.home.homeSectionPresentation.ctaButtonText}
              secondaryButtonStyle
              className="home-section-hero-presentation-header"
            />
          </div>
        </div>
      </div>
      <div className="content-wrapper">
        <div className="home-section-hero-advantages">
          <Row className="justify-content-between">
            <Col md={5} className="position-relative">
              <div className="home-section-hero-image">
                <img src={HeroPeople} alt="" />
              </div>
            </Col>
            <Col md={6}>
              <HomeSectionHeader
                subtitle={dictData.home.homeSectionAdvantages.subtitle}
                title={dictData.home.homeSectionAdvantages.title}
                description={dictData.home.homeSectionAdvantages.description}
                secondaryButtonStyle
              />
              <Row className="home-section-hero-advantages-pros-wrapper">
                <h3 className="home-section-hero-advantages-pros-header col">
                  Wszystkim uczestnikom projektu zapewniamy:
                </h3>
                {dictData.home.homeSectionAdvantages.pros.map((item, id) => {
                  const IconComponent = heroIcons[item.icon as keyof IconsMap];
                  return (
                    <Fragment key={id}>
                      <Col className="home-section-hero-advantages-pros">
                        <div className="home-section-hero-advantages-pros-icon">
                          {IconComponent && <IconComponent />}
                        </div>
                        <div className="home-section-hero-advantages-content">
                          <h3>{parse(item.title)}</h3>
                        </div>
                      </Col>
                      {id !== dictData.home.homeSectionAdvantages.pros?.length - 1 && (
                        <Col className="home-section-hero-advantages-pros">
                          <div className="home-section-hero-advantages-pros-icon hide"></div>
                          <div className="home-section-hero-advantages-content">
                            <div className="home-section-hero-advantages-props-hr"></div>
                          </div>
                        </Col>
                      )}
                    </Fragment>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default HomeSectionHero;
